import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    title: 'b-t b-grey-70 bg-white py-3 fw-medium'
  }
} satisfies CMSConfig['megaMenuL2Mobile']
